import { queryOptions } from '@tanstack/react-query';
import { TrackerTemplatesService } from '@inference.engine/workspace-api-client/web';

import { workspaceHttp } from '@/lib/api/http-client';
import { SUPPRESS_ERROR_NOTIFICATION_HEADER } from '@/lib/api/interceptors/problem-details.interceptor';

import { TRACKER_TEMPLATE_QUERY_KEYS } from './query-keys';

/**
 * The user-saved templates the caller can reuse (org-visible + this workspace +
 * their own private). Product/default templates are added client-side from the
 * built-in catalog, not by this query.
 *
 * The endpoint sits behind its own capability and refuses with a 404 when that
 * is off, which the global interceptor would raise as a persistent toast over a
 * gallery whose built-in half is client-side and perfectly usable. The gallery
 * reports the miss in the group it belongs to instead.
 */
export function trackerTemplatesListQueryOptions(workspaceId: string) {
  return queryOptions({
    queryKey: TRACKER_TEMPLATE_QUERY_KEYS.listByWorkspace(workspaceId),
    queryFn: async () => {
      const response = await TrackerTemplatesService.list({
        client: workspaceHttp,
        // eslint-disable-next-line i18next/no-literal-string -- request header value, never rendered
        headers: { [SUPPRESS_ERROR_NOTIFICATION_HEADER]: 'true' },
      });
      return response.data?.items ?? [];
    },
    enabled: Boolean(workspaceId),
  });
}
